import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20210210/1.png';
import image2 from '@/assets/images/news/detail/20210210/2.png';
import image3 from '@/assets/images/news/detail/20210210/3.png';
import image4 from '@/assets/images/news/detail/20210210/4.png';
import image5 from '@/assets/images/news/detail/20210210/5.png';

export default {
  id: '20210210', //  模块 id
  title: '团市委送温暖｜留沪过年热闹非凡', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '在春节即将来临之际，共青团上海市委员会针对今年响应号召的留沪青年开展春节慰问，对因疫情留沪，并在春节期间继续维护城市运转，民生保障的一线青年群体派送暖心大礼包。',
    },
    {
      type: NewsContentType.Image,
      src: [image1, image2],
    },
    {
      type: NewsContentType.Text,
      text:
        '就在今天，在上海传统的小年夜的一大早，团市委组织部王成部长带队前来叮咚买菜总部，慰问春节留沪的青年员工，为小伙伴们在上海春节期间保供应、保配送、保安全所做出的贡献表达了诚挚的感谢，更送上了贴心的好吃实用的大礼包表达慰问。',
    },
    {
      type: NewsContentType.Image,
      src: [image3, image4],
      customStyle: {
        objectFit: 'unset',
      },
    },
    {
      type: NewsContentType.Text,
      text:
        '团市委还特意安排了天真蓝的志愿者们为我们的一线工作人员拍摄形象照，让春节无法返回家乡与家人团聚的一线员工，可以将自己充实的工作状态和快乐的心情分享给家人。同时，团市委还邀请到六位来自青年联合会的书法家为员工们现场写春联，送福字。现场热闹非凡，叮咚买菜的小哥哥小姐姐们都热情地与书法家互动，将年轻人的想法与传统的春联相结合，书法家们都感到新奇，连称“真是有代沟了呀”，现场笑声一片！',
    },
    {
      type: NewsContentType.Image,
      src: [image5],
      customStyle: {
        objectFit: 'unset',
      },
    },
    {
      type: NewsContentType.Text,
      text: '就地过年不远行，同心战疫力断金！',
    },
    {
      type: NewsContentType.Text,
      text: '祝大家2021牛年大吉，平安顺遂！',
    },
  ],
};
